<template>
    <div class="container">
        <b-container fluid v-if="!showPage">
              <b-row>
                <div class="text-center m-5">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>&nbsp;Loading...</strong>
                </div>
              </b-row>
        </b-container>   
        <b-container fluid v-if="showPage" style="margin-top:100px;">            
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h3>eMGE Table</h3>
                </b-col>
            </b-row>            
             <b-row style="text-align: left;">
                <b-col>
                    <hr>
                    <p> There are <span style="color:red;font-weight: bold;">51,7251 </span> eMGE annotated.</p>
                    <ul>
                        <li>To download table data in CSV format:<a href="file/mgeinfotable.zip" target="_blank"><font-awesome-icon icon="download" ></font-awesome-icon></a></li>
                        <li>To download relative abundance of all eMGEs in CSV format:<a href="file/MGEs_profile_total.zip" target="_blank"><font-awesome-icon icon="download" ></font-awesome-icon></a></li>
                    </ul>
                </b-col>
            </b-row>
            <b-card  align="left">
                <b-card-body>
                    <b-row style="margin-top:10px;margin-bottom:10px">                            
                        <b-col>
                            <b-input-group style="margin-top:10px;margin-bottom:10px">
                                        <b-form-input
                                        v-model="filter"
                                        type="search"
                                        id="filterHmPairs"
                                        placeholder="Type to Search"
                                        @keyup.enter="doFilter"
                                        ></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                                        </b-input-group-append>
                            </b-input-group>                
                        </b-col>
                    </b-row>
                    <b-row style="align:left">
                        <b-col>
                        <b-form-group 
                            label="Filter options"
                            label-for="filt-input">
                            <b-input-group>
                                <b-form-select v-model="filtMod" :options="filtOptions"></b-form-select>
                                <b-form-input id="filt-input" v-model="filtTerm"></b-form-input>
                                <b-button variant="outline-primary" @click="addFilter">Add</b-button>
                            </b-input-group>
                            </b-form-group>
                            <div class="d-inline-block">                            
                            <ul>
                                <li v-for="(btn, idx) in addedFilters"
                                :key="idx" class="listyle">{{filtMap[btn.split(':')[0]]+':'+btn.split(':')[1]}} <a @click="removeFilter(btn)"><font-awesome-icon icon="window-close" size='sm'></font-awesome-icon></a> </li>
                            </ul>
                            </div>
                            <p>
                                <b>Note:</b>
                                The search box can be used to search eMGE ID, cluster ID of the samples only.
                            </p>
                            <!-- <p><download-csv
                            :data   = "procSams" style="cursor: pointer;">
                        To download the filtered table data in CSV format: &nbsp;
                        <font-awesome-icon icon="download" ></font-awesome-icon>
                        </download-csv></p> -->
                        </b-col>                        
                    </b-row>
                </b-card-body>
            </b-card>
            <br/>
            <!-- <b-row>
                <b-col align-self="center">
                    <b-table
                                responsive
                                show-empty
                                :busy.sync="isBusy"
                                :striped="false"
                                :outlined="true"
                                :items="procSams"
                                :fields="tab_fields"
                                :current-page="currentPage"
                                :per-page="perPage"
                                :filter="filter"
                                :filter-function="filterTable"
                            >
                            <template  v-slot:table-busy>
                                      <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                      </div>
                            </template>
                            <template v-slot:cell(MGEs_id) ="row">
                                <router-link :to="{ path: '/viewmge/'+row.item.MGEs_id.trim()}" target="_blank">{{row.item.MGEs_id.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link>
                            </template>
                            <template v-slot:cell(MGEs_cluster) ="row">
                                <span v-if="row.item.MGEs_cluster != 'singlet'">
                                    <router-link :to="{ path: '/viewcluster/'+row.item.MGEs_cluster.trim()}" target="_blank">{{row.item.MGEs_cluster.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link>
                                </span>
                                <span v-else>
                                    {{row.item.MGEs_cluster.trim()}}
                                </span>
                            </template>
                            <template v-slot:cell(host_count) ="row">
                                <span v-if="row.item.host_count != null && row.item.host_count != 'NULL'">
                                    {{row.item.host_count}}
                                </span>
                                <span v-else>
                                    0
                                </span>
                            </template>
                            <template v-slot:cell(completeness) ="row">
                                <span v-if="row.item.completeness != null && row.item.completeness != 'NULL'">
                                    {{parseFloat(row.item.completeness).toFixed(2)}}
                                </span>
                                <span v-else>
                                    NA
                                </span>
                            </template>
                            <template v-slot:cell(Genome_quality) ="row">
                                <span v-if="row.item.Genome_quality != null && row.item.Genome_quality != 'NULL'">
                                    {{row.item.Genome_quality}}
                                </span>
                                <span v-else>
                                    NA
                                </span>
                            </template>
                            <template v-slot:cell(TaxonId) ="row">
                                <span v-if="row.item.TaxonId != null && row.item.TaxonId != 'NULL'">
                                    <a v-bind:href="'https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id='+row.item.TaxonId" target="_blank">{{row.item.TaxonId}}<font-awesome-icon icon="external-link-alt" size='sm'></font-awesome-icon></a> 
                                 </span>
                                <span v-else>
                                    unknown
                                </span>
                            </template>
                            <template v-slot:cell(host_range) ="row">
                                <span v-if="row.item.host_range != null && row.item.host_range != 'NULL'">
                                    {{row.item.host_range}}
                                </span>
                                <span v-else>
                                    unknown
                                </span>
                            </template>
                            <template v-slot:cell(GC_content) ="row">
                                <span v-if="row.item.GC_content != null && row.item.GC_content != 'NULL'">
                                    {{parseFloat(row.item.GC_content).toFixed(2)}}
                                </span>
                                <span v-else>
                                    NA
                                </span>
                            </template>
                    </b-table>
                    <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="currentPage"
                                :total-rows="procSamsSize"
                                :per-page="perPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                    </b-row>
                </b-col>
            </b-row> -->
            <b-row>
                <b-col>
                <div class="overflow-auto" style="width:100%">
                <div v-show="loading" class="overlay flex flex-column items-center justify-center">
                    <spinner size="large" message="loading..."></spinner>
                </div>
                <vuetable ref="vuetable"
                                :api-url="api_adders"
                                :fields="fields"
                                data-path="data"
                                :per-page="10"
                                pagination-path=""
                                :sort-order="sortOrder"
                                v-show="!loading"
                                @vuetable:pagination-data="onPaginationData"
                                :css="css"
                                :show-sort-icons="true"
                                :append-params="moreParams" 
                                @vuetable:loading="onLoading"
                                @vuetable:loaded="onLoaded"
                                >
                                <div slot="MGEs_id" slot-scope="props">
                                    <router-link :to="{ path: '/viewmge/'+props.rowData.MGEs_id.trim()}" target="_blank">{{props.rowData.MGEs_id.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link>
                                </div>
                                <div slot="MGEs_cluster" slot-scope="props">
                                    <span v-if="props.rowData.MGEs_cluster != 'singlet'">
                                        <router-link :to="{ path: '/viewcluster/'+props.rowData.MGEs_cluster.trim()}" target="_blank">{{props.rowData.MGEs_cluster.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link>
                                    </span>
                                    <span v-else>
                                        {{props.rowData.MGEs_cluster.trim()}}
                                    </span>
                                </div>
                                <div slot="sample_count" slot-scope="props">
                                    <span v-if="props.rowData.sample_count != null && props.rowData.sample_count != 'NULL' && props.rowData.sample_count>=1">
                                        {{props.rowData.sample_count}}
                                    </span>
                                    <span v-else>
                                        0
                                    </span>
                                </div>
                                <div slot="study_count" slot-scope="props">
                                    <span v-if="props.rowData.study_count != null && props.rowData.study_count != 'NULL' && props.rowData.study_count>=1">
                                        {{props.rowData.study_count}}
                                    </span>
                                    <span v-else>
                                        0
                                    </span>
                                </div>
                                <div slot="host_count" slot-scope="props">
                                    <span v-if="props.rowData.host_count != null && props.rowData.host_count != 'NULL' && props.rowData.host_count>=1">
                                        {{props.rowData.host_count}}
                                    </span>
                                    <span v-else>
                                        0
                                    </span>
                                </div>
                                <div slot="completeness" slot-scope="props">
                                    <span v-if="props.rowData.completeness != null && props.rowData.completeness != 'NULL' && props.rowData.completeness.length>1">
                                        {{props.rowData.completeness}}
                                    </span>
                                    <span v-else>
                                        NA
                                    </span>
                                </div>
                                <div slot="Genome_quality" slot-scope="props">
                                    <span v-if="props.rowData.Genome_quality != null && props.rowData.Genome_quality != 'NULL' && props.rowData.Genome_quality.length>1">
                                        {{props.rowData.Genome_quality}}
                                    </span>
                                    <span v-else>
                                        NA
                                    </span>
                                </div>
                                <div slot="TaxonId" slot-scope="props">
                                    <span v-if="props.rowData.TaxonId != null && props.rowData.TaxonId != 'NULL' && props.rowData.TaxonId.length>=1">
                                        <a v-bind:href="'https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id='+props.rowData.TaxonId" target="_blank">{{props.rowData.TaxonId}}<font-awesome-icon icon="external-link-alt" size='sm'></font-awesome-icon></a> 
                                    </span>
                                    <span v-else>
                                        unknown
                                    </span>
                                </div>
                                <div slot="host_range" slot-scope="props">
                                    <span v-if="props.rowData.host_range != null && props.rowData.host_range != 'NULL' && props.rowData.host_range.length>1">
                                        {{props.rowData.host_range}}
                                    </span>
                                    <span v-else>
                                        unknown
                                    </span>
                                </div>
                                <div slot="GC_content" slot-scope="props">
                                    <span v-if="props.rowData.GC_content != null && props.rowData.GC_content != 'NULL' && props.rowData.GC_content.length>1">
                                        {{parseFloat(props.rowData.GC_content).toFixed(2)}}
                                    </span>
                                    <span v-else>
                                        NA
                                    </span>
                                </div>                                
                </vuetable>
                <div v-show="!loading">
                    <vuetable-pagination-info ref="paginationInfo"  :css="css.pagination" info-class="pull-left"
                    ></vuetable-pagination-info>
                                    
                    <vuetable-pagination ref="pagination"  :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                    ></vuetable-pagination>
                </div>
                </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import Vuetable from 'vuetable-2';
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import BootstrapStyle from './bootstrap-css.js'
import Spinner from 'vue-simple-spinner'

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        Spinner
    },
    data () {
        return{
            server_add:"https://mai.fudan.edu.cn/",
            loading: true,
            api_adders: "https://mai.fudan.edu.cn/query/listMGEInfoTab",
            showPage:true,
            filter:null,
            isBusy:true,
            tab_data:[],
            tab_fields:[
                { key:'MGEs_id',label:'eMGE ID',sortable:false },
                { key: 'status', label: 'Type', sortable: false },
                { key: 'MGEs_cluster', label: 'eMGE cluster', sortable: true},
                { key: 'host_count', label: 'Host detection', sortable: false},
                { key: 'sample_count', label: 'Samples', sortable: true},
                { key: 'study_count', label: 'Projects', sortable: true},
                { key: 'GC_content', label: 'GC content', sortable: true},
                { key: 'gene_number', label: 'Gene number', sortable: true},
                { key: 'TaxonId', label: 'Taxon Id', sortable: true},
                { key: 'host_range', label: 'Host range', sortable: false},
                { key: 'contig_length', label: 'Length', sortable: true},
                { key: 'structure', label: 'Structure', sortable: true},
                { key: 'completeness', label: 'completeness(%)', sortable: false},
                { key: 'Genome_quality', label: 'Quality', sortable: false},
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10,15,25,35,50],

            fields:[
                { name:'MGEs_id',title:'eMGE ID'},
                { name: 'status', title: 'Type'},
                { name: 'MGEs_cluster', title: 'eMGE cluster', sortField: 'MGEs_cluster'},
                { name: 'host_count', title: 'Host detection'},
                { name: 'sample_count', title: 'Samples', sortField: 'sample_count'},
                { name: 'study_count', title: 'Projects', sortField: 'study_count'},
                { name: 'GC_content', title: 'GC content', sortField: 'GC_content'},
                { name: 'gene_number', title: 'Gene number', sortField: 'gene_number'},
                { name: 'TaxonId', title: 'Taxon Id', sortField: 'TaxonId'},
                { name: 'host_range', title: 'Host range', sortField: false},
                { name: 'contig_length', title: 'Length', sortField: 'contig_length'},
                { name: 'structure', title: 'Structure', sortField: 'structure'},
                { name: 'completeness', title: 'Completeness', sortField: false},
                { name: 'Genome_quality', title: 'Quality', sortField: false},
            ],
            moreParams: {},
            sortOrder: [
                {field: "MGEs_cluster",direction: "asc"},
                {field: "sample_count",direction: "asc"},
                {field: "study_count",direction: "asc"},
                {field: "gene_number",direction: "asc"},
                {field: "GC_content",direction: "asc"},
                {field: "TaxonId",direction: "asc"},
                {field: "contig_length",direction: "asc"},
                {field: "structure",direction: "asc"}
            ],
            hostSel:'',
            hostOptions:[],
            countrySel:'',
            countryOptions:[],
            typeSel:'',
            typeOptions:[],
            tagValue:[],
            tagDirty:false,
            filtMod:'Type',
            filtTerm:'',
            filtOptions:['Type','Structure','Genome quality','Host range'],
            filtMap:{'Type':'status','Structure':'structure','Genome quality':'Genome_quality','Host range':'host_range',
            'status':'Type','structure':'Structure','Genome_quality':'Genome quality','host_range':'Host range'},
            addedFilters:[],
            css: BootstrapStyle
        }
    },
    mounted() {
        // this.loadMgeInfoTab()
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
        this.$events.$on('filter-reset', this.onFilterReset())
    },
    computed: {
        procSams(){
            if(this.tab_data.length){
                let tem = this.tab_data.filter(sam =>{
                    var hasAss = false
                    if(this.filter != null && this.filter.length>=1){
                        // console.log(this.filter)
                        var sup = this.filter                                        
                        if( (sam.MGEs_id != null && sam.MGEs_id.match(sup)) || 
                        (sam.MGEs_cluster != null && sam.MGEs_cluster.match(sup)) ){
                            hasAss = true
                        }
                    }else{
                        hasAss = true
                    }
                    if(this.addedFilters.length>=1){
                        var su = 0
                        this.addedFilters.forEach(ele => {
                            var sp = ele.split(':')
                            if(sp != null  && sam[sp[0]] != null && sam[sp[0]].toLowerCase().match(sp[1].toLowerCase())){
                               su++ 
                            }
                        });
                        return hasAss && su === this.addedFilters.length
                    }else{
                        return hasAss && true
                    }
                })
                return tem
            }
            return null
        },
        procSamsSize(){
            if(this.tab_data.length){
                let tem = this.tab_data.filter(sam =>{
                    var hasAss = false
                    if(this.filter != null && this.filter.length>=1){
                        // console.log(filter)
                        var sup = this.filter                                        
                        if( (sam.MGEs_id != null && sam.MGEs_id.match(sup)) || 
                        (sam.MGEs_cluster != null && sam.MGEs_cluster.match(sup)) ){
                            hasAss = true
                        }
                    }else{
                        hasAss = true
                    }
                    if(this.addedFilters.length>=1){
                        var su = 0
                        this.addedFilters.forEach(ele => {
                            var sp = ele.split(':')
                            if(sp != null  && sam[sp[0]] != null && sam[sp[0]].toLowerCase().match(sp[1].toLowerCase())){
                               su++ 
                            }
                        });
                        return hasAss && su === this.addedFilters.length
                    }else{
                        return hasAss && true
                    }
                })
                return tem.length
            }
            return 0
        }
    },
    watch: {
      tags(newVal, oldVal) {
        this.tagDirty = true
      }
    },
    methods: {
        loadMgeInfoTab(){
            axios.post(this.server_add+'query/listMGEInfoTab',
            {
            }).then(retDat => {
                if(retDat.status == 200){
                    this.tab_data = retDat.data
                    this.showPage = true
                    this.isBusy = false
                    this.totalRows = this.tab_data.length
                }
            }).catch(err => {
                console.log(err)
            })
        },
        filterTable(row,filter) {
            var hasAss = false
            var ar = []
            if(filter.includes(row.MGEs_id) || filter.includes(row.MGEs_cluster)){
                hasAss = true
            }else{
                if(filter != null ){
                    var su = filter.trim()                                        
                    if( (row.MGEs_id != null && row.MGEs_id.match(su)) || 
                    (row.MGEs_cluster != null && row.MGEs_cluster.match(su)) ){
                         hasAss = true
                     }
                }
            }                    
            return hasAss;            
        },
        addFilter(){
            var filtType = this.filtMap[this.filtMod]
            var filtText = this.filtTerm
            if(!this.addedFilters.includes(filtType+':'+filtText)){
                this.addedFilters.push(filtType+':'+filtText)
                this.filtTerm = ''
                this.doSplFilter()
            }
        },
        removeFilter(term){
            var ind = this.addedFilters.indexOf(term)
            if(ind >-1){
                this.addedFilters.splice(ind, 1);
                var fil = this.addedFilters.join(',')
                this.$events.fire('filter-set', fil)
            }
        },        
        tagValidator(tag) {
            var state = false
            var ar = tag.split(":")
            if(ar.length>=2){ //|| (ar[0] === 'length' && ar[1].length >=1 ) 
                if((ar[0] === 'type' && (ar[1] === 'phage' || ar[1] === 'plasmid' || ar[1] === 'possible_plasmid' || ar[1] === 'possible_phage')) || (ar[0] === 'structure' && (ar[1] === 'linear' || ar[1] === 'circular'))){
                    // this.filter += ar[1]+','
                    if(this.filter != null){
                        if(!this.filter.includes(ar[1])){
                            this.filter += ar[1]+','
                        }
                    }else{
                            this.filter = ar[1]+','
                    }
                    state = true
                }
            }
            return state
        },
        clearFilter(){
            this.filter = null
            this.$events.fire('filter-set', this.filter)
        },
        doSplFilter(){
            var fil = this.addedFilters.join(',')
            this.$events.fire('filter-set', fil)
        },
        doFilter () {            
            this.filter = 'mge:'+this.filter
            this.$events.fire('filter-set', this.filter)
        },
        onFilterSet (filter) {
            // console.log('filter-set', filter)
            this.moreParams = {
                'filter': filter
            }
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterReset () {
            // console.log('filter-reset')
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onLoading() {
            this.loading = true
        },
        onLoaded() {
            this.loading = false
        }
    },
}
</script>

<style lang="less">
    #box{
    // background-color: #ECE9E9;
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 5px;
    align-content: left;
    color: black;
}
</style>